import { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './state';
import { LoginData } from './types';

export const initialState: ContainerState = {
  init: {
    loading: true,
    data: {
      npi: 0,
      providerId: 0,
      utm: '',
    },
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset(state) {
      state.init = initialState.init;
    },

    updateInit(state, action: PayloadAction<LoginData>) {
      state.init.loading = false;
      state.init.data = action.payload;
    },
  },
});

export const { actions, reducer, name: sliceKey } = authSlice;
